import React from 'react';
import MultiPage from './MultiPage';
import EditableText from './EditableText';

const SECTION_KEYS = {
  'comments-header--manager': 'manager',
  'comments-header--team': 'team',
  'comments-header--peer': 'peer',
};

function SectionHeader({ colorClass, marginTop }) {
  const sectionKey = SECTION_KEYS[colorClass];
  return (
    <div
      className={`comments-section__header ${colorClass}`}
      style={marginTop ? { marginTop: 16 } : undefined}
    >
      <EditableText
        as="h4"
        path={`wordsOfWisdom.sectionHeaders.${sectionKey}`}
        variant="inline"
        stripInlineWrap
      />
    </div>
  );
}

function buildItems(data) {
  const items = [];
  let hasPrevSection = false;

  function pushSection(comments, colorClass) {
    items.push(
      <SectionHeader
        key={`${colorClass}-header`}
        colorClass={colorClass}
        marginTop={hasPrevSection}
      />
    );
    const flatComments = (comments || []).flatMap((comment) =>
      comment && typeof comment === 'object' && Array.isArray(comment.comments)
        ? comment.comments
        : [comment]
    );
    if (flatComments.length > 0) {
      flatComments.forEach((comment, idx) => {
        items.push(
          <div key={`${colorClass}-${idx}`} className="comments-section__item">
            <p>{typeof comment === 'string' ? comment.trim() : comment}</p>
          </div>
        );
      });
    } else {
      items.push(
        <div key={`${colorClass}-empty`} className="comments-section__item">
          <p className="no-comments">No comments provided.</p>
        </div>
      );
    }
    hasPrevSection = true;
  }

  pushSection(data.managerComments, 'comments-header--manager');
  pushSection(data.teamMemberComments, 'comments-header--team');
  pushSection(data.peerComments, 'comments-header--peer');

  return items;
}

export default function WordsOfWisdomPage({ data, personName, startPageNumber }) {
  const header = (
    <>
      <h2 className="pdf-section-heading">
        <span className="pdf-section-heading__badge">7</span>
        <EditableText
          as="span"
          path="wordsOfWisdom.sectionHeading"
          variant="inline"
          stripInlineWrap
        />{' '}
        <EditableText
          as="span"
          style={{ fontSize: '14px', fontWeight: 'normal' }}
          path="wordsOfWisdom.sectionSubtitle"
          variant="inline"
          stripInlineWrap
        />
      </h2>
      <EditableText
        as="p"
        className="pdf-body-text"
        path="wordsOfWisdom.introLead"
        variant="inline"
        stripInlineWrap
      />
      <EditableText
        as="p"
        className="pdf-body-text"
        path="wordsOfWisdom.question"
        variant="inline"
        stripInlineWrap
      />
    </>
  );

  return (
    <MultiPage
      header={header}
      items={buildItems(data)}
      startPageNumber={startPageNumber}
      personName={personName}
      sliceKey="wordsOfWisdom"
      sectionKey="wordsOfWisdom"
    />
  );
}
